import { renderInline } from "@/lib/usePageContent";

type Props = {
  text: string;
  className?: string;
  boldClassName?: string;
  as?: keyof JSX.IntrinsicElements;
};

/** Renders text with **bold** markdown support. */
export const RichText = ({ text, className, boldClassName = "font-semibold", as: As = "span" }: Props) => {
  const parts = renderInline(text);
  let brKey = 0;
  return (
    <As className={className}>
      {parts.map((p, i) => {
        if (typeof p === "string") {
          // Split on newlines and insert <br /> between segments
          const lines = p.split("\n");
          return (
            <span key={i}>
              {lines.map((line, j) => (
                <span key={j}>
                  {line}
                  {j < lines.length - 1 && <br key={`br-${brKey++}`} />}
                </span>
              ))}
            </span>
          );
        }
        return (
          <strong key={i} className={boldClassName}>
            {p.bold}
          </strong>
        );
      })}
    </As>
  );
};
